import React from "react";
import { Header } from "../header/header";
import { SideBar } from "../sidebar/sidebar";


export const Layout = (props) => {  
  return (
    <>     
      <div id="layout-wrapper">
      <Header/>
      <SideBar/>
        <div className="main-content">{props.children}</div>
        {/* <Footer /> */}
      </div>
    </>
  );
};
